import { useEffect, useState } from "react";

/**
 * Preloads a canvas upload's server `url` in a detached `<video>` so we can
 * swap off the local blob only after the presigned object is buffered.
 */
export function useVideoHandoffReady(
  serverUrl: string | undefined,
  enabled: boolean,
): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled || !serverUrl) {
      setReady(false);
      return;
    }

    const video = document.createElement("video");
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";

    const markReady = () => setReady(true);
    video.addEventListener("loadeddata", markReady);
    video.src = serverUrl;

    return () => {
      video.removeEventListener("loadeddata", markReady);
      video.removeAttribute("src");
      video.load();
      setReady(false);
    };
  }, [enabled, serverUrl]);

  return ready;
}
